<template>
    <!-- ##### Input match result Modal ##### -->
    <!-- <form class="col-auto"> -->
    <div class="modal fade modal-dialog-scrollable" id="inputRankResultModal" tabindex="-1"
        aria-labelledby="inputRankResultModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="inputRankResultModalLabel">ランク登録</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        tabindex="-1"></button>
                </div>
                <div class="modal-body mx-1 px-1">
                    <table id="result-tbl" class="table align-middle table-sm table-bordered table-hover text-center">
                        <thead>
                            <tr data-bs-toggle="modal" data-bs-target="#inputRankResultModal">
                                <th scope="col" class="rank-column"><font-awesome-icon :icon="['fas', 'trophy']"
                                        style="color: #808080;" /></th>
                                <th scope="col" class="event-id-column" colspan="2" nowrap>{{ selectedEventId }}</th>
                                <!-- <th scope="col" class="win-score-column">勝率</th> -->
                                <th scope="col" class="point-clmn">勝</th>
                                <th scope="col" class="point-clmn">負</th>
                                <th scope="col" class="point-clmn">得</th>
                                <th scope="col" class="point-clmn">失</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="entry in selectedEventEntries">
                                <td style="margin:0; padding:0"><input type="number" style='width: 30px;margin:0;font-size: 13pt; border: 1px solid gray;' tabindex="1" v-model="entry.rank"
                                        name="entry-rank"></td>
                                <td class="team-column"><TeamLabelComponent :teamId="entry.team_id_1" /><br><TeamLabelComponent :teamId="entry.team_id_2" v-if="entry.team_id_2 != '' && entry.team_id_1 != entry.team_id_2" />
                                </td>
                                <td class="player-column">{{ entry.player_name_1 }}<br>{{ entry.player_name_2 }}</td>
                                <!-- <td>3.99</td> -->
                                <td>{{ entry.won_count }}</td>
                                <td>{{ entry.lost_count }}</td>
                                <td>{{ entry.point_gained }}</td>
                                <td>{{ entry.point_lost }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <span style="font-size:10pt;color:#808080"><font-awesome-icon :icon="['fas', 'circle-info']" /> 勝数(多)、試合数(多)、得失点残(多)</span>
                </div>
                <div class="modal-footer">
                    <div>
                        <span>

                            <button type="button" class="btn btn-sm btn-secondary" tabindex="5"
                                data-bs-dismiss="modal">戻る</button>&nbsp;
                            <button type="button" class="btn btn-sm btn-outline-primary filter-btn filter-reset-btn"
                                id="clear-button" tabindex="4" @click="clearRankValue()">クリア</button>&nbsp;
                            <button type="button" class="btn btn-sm btn-warning filter-btn filter-reset-btn"
                                id="clear-button" tabindex="2" @click="setRankValue()">自動順位入力</button>&nbsp;
                            <button type="button" class="btn btn-sm btn-primary" tabindex="3" data-bs-dismiss="modal"
                                @click="saveRankValue()">保存する</button>
                        </span>
                    </div>
                    <div>
                        <span v-if="errorMessage" style="color: red"><br> error message </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- </form> -->
    <!-- ##### End of Form ##### -->
    <div class="text-center" v-if="isLoading">
        <div class="spinner-border spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';
import { getAuth } from "firebase/auth";
import { ref as fbRef, getDatabase, child, get, update } from "firebase/database"
import { routeLocationKey } from 'vue-router';
import TeamLabelComponent from './TeamLabelComponent.vue';

const props = defineProps(['selectedEventId', 'selectedEventEntries']);
const emit = defineEmits(["doReload"])
const isLoading = ref()

const db = getDatabase();
const dbRef = fbRef(db);
const auth = getAuth();
const user = auth.currentUser;

const errorMessage = ref();

onMounted(() => {
});

const setRankValue = () => {
    var rank = 1;
    const entries = props.selectedEventEntries;
    for (var entry in entries) {
        props.selectedEventEntries[entry].rank = rank;
        rank = rank + 1;
    }
}

const saveRankValue = async () => {

    if (user && user.email) { // TODO role
        const entries = props.selectedEventEntries;
        isLoading.value = ref(true);
    
        for (var entry in entries) {
            const new_entry = ref([]);
            const entry_id = props.selectedEventEntries[entry].event_id + "-" + props.selectedEventEntries[entry].entry_id;
            await get(child(dbRef, '/2026-summer/entries/' + entry_id))
            .then(async (snapshot) => {
                if (snapshot.exists()) {
                    new_entry.value = snapshot.val();
                    new_entry.value.rank = props.selectedEventEntries[entry].rank;
                    const updates = {};
                    updates['/2026-summer/entries/' + entry_id] = new_entry.value;
                    await update(dbRef, updates)
                    .then( async () => {
                        console.log("Rank(" + props.selectedEventEntries[entry].rank + ") updated succssfully." + entry_id);
                    })
                    .catch((error) => {
                        console.error(error)
                        throw (error)
                    });
                } else {
                    console.warn("No entry data " + entry_id)
                }
            }).catch((error) => {
                errorMessage = error
                console.error(error)
            // }).then(async () => {
            //     if (props.selectedEventEntries[entry].rank == "") {
            //         updateTournamentEntry(
            //             props.selectedEventEntries[entry].event_id, 
            //             props.selectedEventEntries[entry].rank,
            //             "", "", "", "");
            //     } else {
            //         updateTournamentEntry(
            //         props.selectedEventEntries[entry].event_id, 
            //         props.selectedEventEntries[entry].rank,
            //         props.selectedEventEntries[entry].team_id_1,
            //         props.selectedEventEntries[entry].player_name_1,
            //         props.selectedEventEntries[entry].team_id_2,
            //         props.selectedEventEntries[entry].player_name_2);

            //     }
            });
        }
        await get(child(dbRef, '/2026-summer/entries'))
        .then((snapshot) => {
            if (snapshot.exists()) {
                entries.value = snapshot.val();
                localStorage.setItem('entries', JSON.stringify(snapshot.val()));
            } else {
                console.log('No data available')
            }
        }).catch((error) => {
            console.error(error)
        })
        // console.log("doing reload")
        emit('doReload');
        isLoading.value = false;
    }

}

const updateTournamentEntry = async (event_id, rank, team_id_1, player_name_1, team_id_2, player_name_2) => {
    console.log("update tournament entry" + event_id + "-" + rank)
    console.log(team_id_1 + player_name_1)
    console.log(team_id_2 + player_name_2)

    const allEntries = JSON.parse(localStorage.getItem("entries"));
    const selectedEntry = ref([]);
    selectedEntry.value = allEntries;
    selectedEntry.value = Object.fromEntries(
        Object.entries(selectedEntry.value).filter(([key, value]) =>
        ("rank-" + event_id + "-" + rank == value.entry_from))
    );
    
    const entry_id = Object.keys(selectedEntry.value)[0];
    await get(child(dbRef, '/2026-summer/entries/' + entry_id))
    .then(async (snapshot) => {
        if (snapshot.exists()) {
            const new_entry = ref([]);
            new_entry.value = snapshot.val();
            new_entry.value.team_id_1 = team_id_1;
            new_entry.value.player_name_1 = player_name_1;
            new_entry.value.team_id_2 = team_id_2;
            new_entry.value.player_name_2 = player_name_2;
            console.log(JSON.stringify(new_entry))
            const updates = {};
            updates['/2026-summer/entries/' + entry_id] = new_entry.value;
            await update(dbRef, updates)
            .then( async () => {
                //console.log("Rank(" + props.selectedEventEntries[entry].rank + ") updated succssfully." + entry_id);
            })
            .catch((error) => {
                console.error(error)
                throw (error)
            });
        } else {
            console.warn("No entry data " + entry_id)
        }
    });
}

const clearRankValue = () => {
    const entries = props.selectedEventEntries;
    for (var entry in entries) {
        props.selectedEventEntries[entry].rank = "";
    }
}

</script>

<style scoped>
th.rank-column {
    background-color: #ffcd39;
}

th.win-score-column {
    background-color: #ffcd39;
}

th.point-clmn {
    background-color: #e9ecef;
}

.event-id-column {
    background-color: #d1e7dd;
}

.team-column {
    border-right: none;
}

.player-column {
    text-align: left;
    border-left: none;
}

.spinner {
  position: fixed;
  left: 50%;
  top: 20%;
  margin: 0px auto;
  z-index: 999;
}
</style>